import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { LoginComponent } from './login/login.component';
import { RegisterComponent } from './register/register.component';
import { AuthenticationRoutingModule } from './authentication-routing.module';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { SnotifyModule, SnotifyService } from 'ng-snotify';
import { HttpClient, HTTP_INTERCEPTORS } from '@angular/common/http';
import { AuthInterceptor } from '../shared/network/interceptors/auth.interceptor';
import { MainInterceptor } from '../shared/network/interceptors/main.interceptor';
import { ErrorHandlerInterceptor } from '../shared/network/interceptors/error-handler.interceptor';
import { ResetPasswordComponent } from './reset-password/reset-password.component';
import { SharedModule } from '../shared/shared.module';
import { NgxBootstrapMultiselectDropdownModule } from 'ngx-bootstrap-multiselect-dropdown';


@NgModule({
  declarations: [
  LoginComponent,
  RegisterComponent,
  ResetPasswordComponent,
  ],
  imports: [
    CommonModule,
    NgxBootstrapMultiselectDropdownModule,
    ReactiveFormsModule,
    FormsModule,
    RouterModule,
    AuthenticationRoutingModule,
    SharedModule
  ],
  exports: [],
  providers: [
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthInterceptor,
      multi: true
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: MainInterceptor,
      multi: true
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: ErrorHandlerInterceptor,
      multi: true
    },
  ]

})
export class AuthenticationModule { }
